import PropTypes from 'prop-types';

import { HomeCheckerShape } from '@spotahome/ui-library/src/tenant/shapes/HomeChecker';

import listingOfferShape from './listingOffer';

export const CoordsShape = PropTypes.arrayOf(PropTypes.number);

export const PhotoListShape = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    verified: PropTypes.bool,
    caption: PropTypes.string
  })
);

export const ListingShape = {
  adId: PropTypes.string,
  address: PropTypes.string,
  hasOffer: PropTypes.bool,
  id: PropTypes.string,
  type: PropTypes.string,
  countryCode: PropTypes.string,
  cityId: PropTypes.string,
  isBookable: PropTypes.bool,
  areaInfo: PropTypes.shape({
    slug: PropTypes.string,
    limits: PropTypes.shape({
      sw: CoordsShape,
      ne: CoordsShape
    })
  }),
  coords: CoordsShape,
  photos: PropTypes.shape({
    floorplanList: PropTypes.arrayOf(PropTypes.string),
    photos360List: PhotoListShape,
    photoList: PhotoListShape
  }),
  videos: PropTypes.shape({}),
  roomsInApartment: PropTypes.arrayOf(PropTypes.shape({})),
  otherRooms: PropTypes.arrayOf(PropTypes.shape({})),
  contents: PropTypes.shape({
    isManualTranslated: PropTypes.bool,
    isTranslationNeeded: PropTypes.bool,
    [PropTypes.string]: PropTypes.shape({})
  }),
  neighVid: PropTypes.shape({}),
  ptype: PropTypes.shape({
    url: PropTypes.string,
    breadcrumbLabel: PropTypes.string,
    type: PropTypes.string
  }),
  runner: PropTypes.shape(HomeCheckerShape),
  instantBooking: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  reviews: PropTypes.shape({
    count: PropTypes.number,
    ratingAverage: PropTypes.number
  }),
  minStay: PropTypes.number,
  maxStay: PropTypes.number,
  cancellationPolicy: PropTypes.string,
  contractType: PropTypes.string,
  availableFromDateIso8601: PropTypes.string,
  landlordRules: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    })
  }),
  bookingAcceptanceMaxDays: PropTypes.number,
  pricing: PropTypes.shape({
    currencyLabel: PropTypes.string,
    price: PropTypes.number
  }),
  unavailabilities: PropTypes.arrayOf(),
  availabilities: PropTypes.arrayOf(),
  moveInDatesRanges: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string
    })
  ),
  checked: PropTypes.bool,
  offers: PropTypes.arrayOf(PropTypes.shape(listingOfferShape)),
  landlordId: PropTypes.string.isRequired,
  verificationDate: PropTypes.string,
  plan: PropTypes.string
};

export default {
  CoordsShape,
  PhotoListShape
};
